import { useQueryErrorStateContext } from 'modules/queryBuilder/contexts';
import { PAGE_VARIATIONS } from 'modules/segmentation/constants';
import { useListDetailsContext } from 'modules/segmentation/contexts/listDetails';
import { constructWarningPath } from '../utils/constructWarningPath';

const VALUES = 'values';

export const useValidateEmptyValues = () => {
  const { removePathWarning, addPathWarning } = useQueryErrorStateContext();
  const { pageVariation } = useListDetailsContext();

  return ({ values }: { values?: string[] }, validationPath: (string | number)[]) => {
    if (!Array.isArray(values)) return;

    const constructedPath = constructWarningPath(validationPath, VALUES);

    // Remove warnings if no longer valid or if page is not a dynamic saved list
    if (values.length !== 0 || pageVariation !== PAGE_VARIATIONS.DYNAMIC) {
      removePathWarning(constructedPath);
    } else {
      addPathWarning(constructedPath, 'condition was saved with empty values');
    }
  };
};
